<template>
  <div class="visitor-index">
    <div class="home-body">
      <Media />
      <Service />
    </div>
  </div>
</template>

<script>
import Service from "./service/service.vue";
import Media from "./media/media.vue";
export default {
  components: { Service, Media },
  data() {
    return {
      serachVal: '',
      searchShow: false,
      moudleList: [
        [
          { name: "service", type: "short", id: 2 },
          { name: "sso", type: "long", id: 1 },
        ],
        [{ name: "media", type: "overlong", id: 5 }],
      ],
      selectList: [
        {id: '0', label: '全部'},
        {id: '1', label: '服务事项'},
        {id: '2', label: '应用'},
        {id: '3', label: '通知公告'}
      ]
    }
  },
  methods: {
    searchRes(val, selectVal) {
      console.log(val, selectVal);
    },
    /** 拖拽结束前 */
    dragEnd() {},
    /** 拖动时判断 */
    onMove() {},
    // 模块拖动结束
    mpudleDragEnd() {
      this.$nextTick(async () => this.sendRequest());
    },
  }
}
</script>

<style lang='less' scoped>
  .visitor-index {
    width: 100%;
    position: relative;
    .home-header {
      height: 300px;
      position: relative;
      z-index: 1;
      .carousel {
        position: relative;
      }
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }
      .user-search {
        position: absolute;
        z-index: 2;
        width: 350px;
        bottom: 30px;
        right: 30px;
        .el-input__inner {
          background: rgba(0,0,0,0.4000);
          border-color: rgba(0,0,0,0.4000);
          border-radius: 24px;
          color: #fff;
        }
        .el-input__suffix {
          right: 14px;
          cursor: pointer;
        }
      }
    }
    // 主体区域
    .home-body {
      // 主页布局模块
      .home-layout-item {
        margin-top: 30px;
        min-height: 300px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>